import { useIsOptimizedAudioBarsEnabled } from '@/features/flags';
import type { ComponentProps } from 'react';
import { BarsBase as LegacyBarsBase } from './legacy/BarsBase';
import { BarsBase as OptimizedBarsBase } from './optimized/BarsBase';

/**
 * SCR-6633 rollout switch: ON renders the compositor-backed optimized bars,
 * OFF the pre-SCR-6633 implementation (byte-identical under `legacy/`).
 * Imperative height writers pair with whichever variant is mounted — both
 * resolve from the same flag in the same render pass.
 */
export const BarsBase = (props: ComponentProps<typeof OptimizedBarsBase>) =>
  useIsOptimizedAudioBarsEnabled() ? (
    <OptimizedBarsBase {...props} />
  ) : (
    <LegacyBarsBase {...props} />
  );
